// extracted by mini-css-extract-plugin
export var container = "BuildingScreen-module--container--xJuFT";
export var contentContainer = "BuildingScreen-module--contentContainer--Yl2DR";
export var titleContainer = "BuildingScreen-module--titleContainer--F4J5n";
export var title = "BuildingScreen-module--title--LB5Ws";
export var dots = "BuildingScreen-module--dots--+rBCx";
export var text = "BuildingScreen-module--text--yFtQU";
export var smallText = "BuildingScreen-module--smallText--q4Huw";
export var answersContainer = "BuildingScreen-module--answersContainer--7XcB2";
export var answer = "BuildingScreen-module--answer--zfH-e";
export var selectedAnswer = "BuildingScreen-module--selectedAnswer--3VxcE";